import { useSelector } from 'react-redux';
import {
	useGetRecruitingManagersQuery,
	useGetStagesQuery,
} from '../../store/apiSlices/recruitApiSlice';
import { RootState } from '../../store/store';
import { DropdownModel } from '../../models/dropdown.model';
import DashboardSections from './Dashboard';

const Dashboard = () => {
	const userInfo = useSelector((store: RootState) => store.user);
	const recruitingManagers = useGetRecruitingManagersQuery({
		userEmail: userInfo.user_email,
		isSysAdmin: !userInfo.roles.adminAppAccessedUserListInclusion,
	});
	const stageIds = useGetStagesQuery(null);
	return (
		<>
			{recruitingManagers?.isSuccess && stageIds?.isSuccess ? (
				<DashboardSections
					recruitingManagers={
						recruitingManagers.currentData?.value as DropdownModel[]
					}
					stageIds={stageIds.currentData?.value as DropdownModel[]}
				/>
			) : null}
		</>
	);
};
export default Dashboard;
